import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from './slices';

import * as Sentry from "@sentry/react";


if (process.env.SENTRY_ENV == "development") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations : [
       Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate:1.0,
    environment: "development",
  })
} else{
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations  : [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate:1.0,
    environment: "production"
  })
}

// Sentry.init({
//   dsn: process.env.REACT_APP_SENTRY_DSN,
//   integrations : [
//      Sentry.browserTracingIntegration(),
//   ],
//   tracesSampleRate:1.0,
// })

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const store = configureStore({ reducer: rootReducer, devTools: true });
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
